export enum Produto {
    IM = 'IM',
    EM = 'EM',
    IA = 'IA',
    EA = 'EA',
    TR = 'TR',
    CB = 'CB',
    ADM = 'ADM'
}